import { ToggleFeaturesType } from '../types'

const windowFeaturesGate = window.featuresGate || {}

export const bookingFeatures: ToggleFeaturesType = {
  client_booking_limit: windowFeaturesGate.CLIENT_BOOKING_LIMIT ?? true, // fallback to true if undefined
  gtm_datalayer: windowFeaturesGate.GTM_DATALAYER_BOOKING ?? false
}
